export default __webpack_public_path__ + "static/media/love-active.6739a115.svg";